import { ISortStatuses } from '@/fsd/shared/model/types/ISortStatuses';

export const getSortStatus = (
  sorted: string[],
  field: string
): ISortStatuses => {
  console.log(sorted);
  if (sorted.includes(field)) {
    return 'asc';
  }
  if (sorted.includes(`-${field}`)) {
    return 'desc';
  }
  return undefined;
};
